module.exports = __webpack_public_path__ + "static/media/richard.0599378c.jpg";